
 [
    {"FeatureId" :160,"FeatureName":"UserReports"},
    {"FeatureId" :161,"FeatureName":"UserReports"},
    {"FeatureId" :170,"FeatureName":"UserReport"},
    {"FeatureId" :171,"FeatureName":"TrainingReports"},
    {"FeatureId" :172,"FeatureName":"DocumentReports"},
    {"FeatureId" :173,"FeatureName":"MessageReports"},
    {"FeatureId" :174,"FeatureName":"FAQReports"},
    {"FeatureId" :175,"FeatureName":"TrainingModuleCompletionReport"},
    {"FeatureId" :176,"FeatureName":"TrainingModuleTrackingReport"},
    {"FeatureId" :177,"FeatureName":"DocumentDownloadTrackingReport"},
    {"FeatureId" :178,"FeatureName":"DocumentManagementReport"},
    {"FeatureId" :179,"FeatureName":"DocumentPermissionReport"},
    {"FeatureId" :180,"FeatureName":"MessageManagementReport"},
    {"FeatureId" :181,"FeatureName":"MessageAcknowledgementReport"},
    {"FeatureId" :182,"FeatureName":"FAQManagementReport"},
    {"FeatureId" :225,"FeatureName":"TeamDocumentReports"},
    {"FeatureId" :226,"FeatureName":"TeamDocumentDownloadTrackingReport"},
    {"FeatureId" :227,"FeatureName":"TeamDocumentManagementReport"},
    {"FeatureId" :228,"FeatureName":"TeamDocumentPermissionReport"},
    {"FeatureId" :232,"FeatureName":"AskaQuestionReport"},
    {"FeatureId" :233,"FeatureName":"QuestionsReport"},
    {"FeatureId" :275,"FeatureName":"TrainingStatusOverrideReport"},
    {"FeatureId" :287,"FeatureName":"SiteCRAAssignmentReport"},
    {"FeatureId" :380,"FeatureName":"SafetyReports"},
    {"FeatureId" :381,"FeatureName":"SafetyReportsCompletionSummaryReport"},
    {"FeatureId" :382,"FeatureName":"SafetyReportsCompletionDetailReport"},
    {"FeatureId" :383,"FeatureName":"EnterpriseReports"},
    {"FeatureId" :384,"FeatureName":"EnterpriseUserReport"},
    {"FeatureId" :385,"FeatureName":"EnterpriseTrainingTrackingReport"},
    {"FeatureId" :394,"FeatureName":"SafetyReportsManagementReport"},
    {"FeatureId" :414,"FeatureName":"TrainingModuleTrackingReportOLD"},
    {"FeatureId" :432,"FeatureName":"DiscussionReports"},
    {"FeatureId" :433,"FeatureName":"PollResultsReport"},
    {"FeatureId" :434,"FeatureName":"DiscussionActivitySummaryByTopicReport"},
    {"FeatureId" :435,"FeatureName":"DiscussionPostsByUserReport"},
    {"FeatureId" :436,"FeatureName":"DiscussionPostsByTopicReport"},
    {"FeatureId" :461,"FeatureName":"TrainingQuestionsResponseReport"},
    {"FeatureId" :475,"FeatureName":"SafetyReportsDistributionReport"},
    {"FeatureId" :159,"FeatureName":"MedPointReports"},
{"FeatureId" :276,"FeatureName":"TrainingReports"},
{"FeatureId" :312,"FeatureName":"UserReports"},
{"FeatureId" :314,"FeatureName":"UserReport"},
{"FeatureId" :315,"FeatureName":"SiteCRAAssignmentReport"},
{"FeatureId" :316,"FeatureName":"TrainingModuleCompletionReport"},
{"FeatureId" :317,"FeatureName":"TrainingModuleTrackingReport"},
{"FeatureId" :319,"FeatureName":"TrainingStatusOverrideReport"},
{"FeatureId" :320,"FeatureName":"DocumentReports"},
{"FeatureId" :321,"FeatureName":"DocumentDownloadTrackingReport"},
{"FeatureId" :322,"FeatureName":"DocumentManagementReport"},
{"FeatureId" :323,"FeatureName":"DocumentPermissionReport"},
{"FeatureId" :333,"FeatureName":"MessageReports"},
{"FeatureId" :334,"FeatureName":"MessageManagementReport"},
{"FeatureId" :335,"FeatureName":"MessageAcknowledgementReport"},
{"FeatureId" :336,"FeatureName":"FAQReports"},
{"FeatureId" :337,"FeatureName":"FAQManagementReport"},
{"FeatureId" :340,"FeatureName":"TeamDocumentReports"},
{"FeatureId" :341,"FeatureName":"TeamDocumentDownloadTrackingReport"},
{"FeatureId" :342,"FeatureName":"TeamDocumentManagementReport"},
{"FeatureId" :343,"FeatureName":"TeamDocumentPermissionReport"},
{"FeatureId" :344,"FeatureName":"AskaQuestionReport"},
{"FeatureId" :345,"FeatureName":"QuestionsReport"},
{"FeatureId" :395,"FeatureName":"SafetyReports"},
{"FeatureId" :396,"FeatureName":"ProgramLevelSafetyReportsAssignmentReport"},
{"FeatureId" :397,"FeatureName":"SafetyReportsCompletionSummaryReport"},
{"FeatureId" :398,"FeatureName":"SafetyReportsCompletionDetailReport"},
{"FeatureId" :399,"FeatureName":"SafetyReportsManagementReport"},
{"FeatureId" :448,"FeatureName":"DiscussionReports"},
{"FeatureId" :449,"FeatureName":"PollResultsReport"},
{"FeatureId" :450,"FeatureName":"DiscussionActivitySummaryByTopicReport"},
{"FeatureId" :451,"FeatureName":"DiscussionPostsByUserReport"},
{"FeatureId" :452,"FeatureName":"DiscussionPostsByTopicReport"},
{"FeatureId" :453,"FeatureName":"EnterpriseReports"},
{"FeatureId" :454,"FeatureName":"EnterpriseUserReport"},
{"FeatureId" :455,"FeatureName":"EnterpriseTrainingTrackingReport"},
{"FeatureId" :463,"FeatureName":"TrainingQuestionsResponseReport"},
{"FeatureId" :476,"FeatureName":"SafetyReportsDistributionReport"},
{"FeatureId" :515,"FeatureName":"TrainingRequirementsOverrideReport"},
{"FeatureId" :516,"FeatureName":"TrainingRequirementsOverrideReport"}

]
